(function () {
    'use strict';

    angular.module('finansApp.courseFilterService', []).factory('courseFilterService', courseFilterService);
    

    function State() {
        this.showFilter = 0;
        this.mobileFilter = false;
        this.filter = {
            "SubjectAreas": [],
            "Types": [],
            "TargetAudiences": []
        };

    }

    courseFilterService.$inject = ['$filter', '$q'];

    function courseFilterService($filter, $q) {
        var state = new State(); 


        // Public
        var service = {
            state: state,
            filterCourses: filterCourses
        };

        function filterCourses (arr)  {
            var deferred = $q.defer();

            var arrFiltered = [];
            arrFiltered = filterArray(arr, state.filter.SubjectAreas, "SubjectAreas");
            arrFiltered = filterArray(arrFiltered, state.filter.TargetAudiences, "TargetAudiences");
            arrFiltered = filterOnValue(arrFiltered, state.filter.Types, "CourseTypeNodeId");

            deferred.resolve(arrFiltered);

            
            return deferred.promise;
        }

                // Is used is the filterKey is a array of integers 
        function filterArray(array, filterValues, filterKey) {
            var temp = [];


            // Check if there has been chosen any facilities
            if(filterValues == null || !filterValues.length) {
                return array;
            }
            // Loop over all the items
            for (var i = array.length - 1; i >= 0; i--) {

                var isInArray = false;

                // Loop over the filter
                for (var j = filterValues.length - 1; j >= 0; j--) {

                    // Parse the value to a int, since the values on the items are set as ints
                    var valueAsInt = filterValues[j] * 1;

                    
                    if(contains.call(array[i][filterKey], valueAsInt) && !isInArray) {
                        temp.push(array[i]);
                        isInArray = true;
                    }
                }
            }

            return temp;
        }
        
        // Is used is the filterKey is a integer
        function filterOnValue(array, filterValues, filterKey) {

            var temp = [];
             // Check if there has been chosen any facilities
             if(filterValues == null || !filterValues.length) {
                return array;
             }

            // Loop over all the items
            for (var i = array.length - 1; i >= 0; i--) {

                // Loop over the filter
                for (var j = filterValues.length - 1; j >= 0; j--) {

                    // Parse the value to a int, since the values on the items are set as ints
                    var valueAsInt = filterValues[j] * 1;

                    // Check if the the facility in the array of facilities on the hotel
                    if(array[i][filterKey] == valueAsInt) {
                        temp.push(array[i]);
                    }
                }
            }

            return temp;
        }

        // Helper method to check if a array contains a value
        var contains = function(needle) {
            // Per spec, the way to identify NaN is that it is not equal to itself
            var findNaN = needle !== needle;
            var indexOf;

            if(!findNaN && typeof Array.prototype.indexOf === 'function') {
                indexOf = Array.prototype.indexOf;
            } else {
                indexOf = function(needle) {
                    var i = -1, index = -1;

                    for(i = 0; i < this.length; i++) {
                        var item = this[i];

                        if((findNaN && item !== item) || item === needle) {
                            index = i;
                            break;
                        }
                    }

                    return index;
                };
            }

            return indexOf.call(this, needle) > -1;
        };



        
        return service;



    }

})();

